import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Детски калъфки за възглавници от памучен сатен – 100% памук | GoToBed',
  description:
    'Детски калъфки за възглавници от памучен сатен, 100% памук. Размери 30/40, 35/53, 40/60, 50/70. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Детски калъфки за възглавници от памучен сатен
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Детски калъфки за възглавници от памучен сатен – 100% памук и различни размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Калъфките за детски възглавници от памучен сатен са изработени от 100% памук и се
          отличават с гладка и мека повърхност. Фината и дишаща материя осигурява приятно усещане по
          време на сън. Калъфките се изработват по поръчка и се предлагат в разнообразие от размери,
          включително популярните 30/40, 35/53, 40/60, 50/70.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyDetskiKalufkiSaten />;
}

function SeoBodyDetskiKalufkiSaten() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Детски калъфки за възглавници от памучен сатен – 100% памук */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Детски калъфки за възглавници от памучен сатен – 100% памук
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Калъфките за детски възглавници от памучен сатен са отличен избор за родители, които търсят
        мека, гладка и приятна на допир памучна материя за детско спално бельо. Памучният сатен е
        висококачествен 100% памучен плат, който се отличава с фин допир, гладка структура и лек
        естествен блясък.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В тази категория ще откриете детски калъфки за възглавници от памучен сатен, които
        осигуряват комфорт и приятно усещане по време на сън. Материята е дишаща и нежна към кожата,
        което я прави подходяща за чувствителната кожа на бебета и деца.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всички калъфки се изработват внимателно в България от платове със сертификат OEKO-TEX
        Standard 100, който гарантира, че текстилът е безопасен и не съдържа вредни вещества.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        За да създадете пълен комплект детско спално бельо от същата материя, можете да комбинирате
        калъфките с
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-plikove/2/10/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски пликове памучен сатен
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-charshafi/2/7/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски чаршафи памучен сатен
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-charshafi-s-lastik/2/9/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски чаршафи с ластик памучен сатен
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Размери детски калъфки за бебешки и детски възглавници */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Размери детски калъфки за бебешки и детски възглавници
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Нашите детски калъфки за възглавници от памучен сатен се предлагат в много различни
          размери. Това позволява лесно да намерите подходяща калъфка за бебешка или детска
          възглавница.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме калъфки в следните размери:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '28/35',
            '30/40',
            '33/43',
            '33/66',
            '35/53',
            '37/47',
            '40/50',
            '40/60',
            '43/63',
            '48/68',
            '50/70',
            '60/60',
            '70/70'
          ].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Сред най-търсените са:
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 2 }}>
          <li>калъфка 30/40 (30х40) см за бебешка възглавница</li>
          <li>калъфка 35/53 (35х53) см за детска възглавница</li>
          <li>калъфка 40/60 (40х60) см за детска възглавница</li>
          <li>калъфка 50/70 (50х70) см за стандартна възглавница</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на този богат избор можете лесно да намерите подходяща калъфка за възглавница
          за бебе или дете, дори когато размерът е по-нестандартен.
        </Typography>

        {/* H2: Какво представлява памучният сатен? */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какво представлява памучният сатен?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Памучният сатен е 100% памучен плат, който се изработва чрез специален начин на тъкане.
          Тази технология придава на материята по-гладка повърхност и лек естествен блясък, което
          създава по-фино и приятно усещане.
        </Typography>
        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Основни предимства на памучния сатен
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
          <li>&#10004; 100% естествен памук</li>
          <li>&#10004; гладка и мека материя</li>
          <li>&#10004; приятен допир до кожата</li>
          <li>&#10004; добра дишаемост</li>
          <li>&#10004; комфорт по време на сън</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Калъфките от памучен сатен са подходящ избор за родители, които търсят по-фино и меко
          детско спално бельо.
        </Typography>

        {/* H2: Предимства на нашите детски калъфки от памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на нашите детски калъфки от памучен сатен
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
          <li>&#10004; изработени от 100% памучен сатен</li>
          <li>&#10004; гладка и приятна на допир материя</li>
          <li>&#10004; голям избор от размери</li>
          <li>&#10004; подходящи за бебешки и детски възглавници</li>
          <li>&#10004; платове със сертификат OEKO-TEX Standard 100</li>
          <li>&#10004; безопасни за чувствителната детска кожа</li>
          <li>&#10004; произведени в България</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Нашите детски калъфки от памучен сатен са практично решение за родители, които търсят
          качествено, безопасно и удобно детско спално бельо.
        </Typography>

        {/* H2: Популярни размери детски калъфки от памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери детски калъфки от памучен сатен
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 4 }}>
          <li>калъфка 30/40 за бебешка възглавница</li>
          <li>калъфка 35/53 за детска възглавница</li>
          <li>калъфка 40/60 за детска възглавница</li>
          <li>калъфка 50/70 за стандартна възглавница</li>
        </Box>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички калъфки се изработват индивидуално след направена поръчка, според избрания размер.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на 4–7 работни дни.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за детски калъфки от памучен сатен
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер калъфка за детска възглавница?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            За да изберете подходяща калъфка за детска възглавница, измерете ширината и дължината на
            възглавницата и изберете калъфка със същия размер. В нашия магазин ще откриете голямо
            разнообразие от размери калъфки, което позволява лесно да намерите подходящата калъфка
            за бебешка или детска възглавница.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящ ли е памучният сатен за детско спално бельо?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Памучният сатен е 100% памучен плат, който е мек, дишащ и приятен на допир. Това го
            прави много подходящ за детско спално бельо и калъфки за възглавници, защото осигурява
            комфорт и добра циркулация на въздуха.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свиват ли се калъфките от памучен сатен след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички изделия от 100% памук, и калъфките от памучен сатен могат да имат
            естествена свиваемост около 4–5% след първите пранета. Това е нормално свойство на
            памучните материи.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са калъфките за различни размери възглавници?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Предлагаме детски калъфки за възглавници в много различни размери, което позволява
            да намерите подходящ размер както за бебешки възглавници, така и за по-големи детски
            възглавници.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват калъфките?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички детски калъфки от памучен сатен се изработват в България, специално за всяка
            поръчка и според избрания размер.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            За колко време се изработва калъфка за възглавница?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Калъфките се изработват индивидуално по поръчка, като срокът за изработка е между 3 и 10
            работни дни. В повечето случаи поръчките са готови в рамките на 4–7 работни дни.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
